const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-rejected",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-progress-rejected1",
    serifid: "iconB-progress-rejected"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.674,12.019l-2.545,-2.545c-0.179,-0.178 -0.279,-0.42 -0.279,-0.673c0,-0.522 0.43,-0.951 0.952,-0.951c0.252,-0 0.494,0.1 0.673,0.278l2.544,2.546l2.545,-2.546c0.178,-0.178 0.42,-0.278 0.673,-0.278c0.522,-0 0.951,0.429 0.951,0.951c0,0.253 -0.1,0.495 -0.278,0.673l-2.546,2.545l2.546,2.544c0.178,0.179 0.278,0.421 0.278,0.673c0,0.522 -0.429,0.952 -0.951,0.952c-0.253,-0 -0.495,-0.1 -0.673,-0.279l-2.545,-2.545l-2.544,2.544c-0.178,0.179 -0.421,0.28 -0.673,0.28c-0.253,0 -0.495,-0.1 -0.673,-0.279c-0.179,-0.178 -0.279,-0.42 -0.279,-0.673c-0,-0.252 0.1,-0.495 0.279,-0.673l2.545,-2.544Z",
    style: {
      fill: "#d30000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.071,0 11,4.929 11,11c-0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c-0,-6.071 4.929,-11 11,-11Zm-0,1.986c-4.975,0 -9.014,4.039 -9.014,9.014c0,4.975 4.039,9.014 9.014,9.014c4.975,-0 9.014,-4.039 9.014,-9.014c-0,-4.975 -4.039,-9.014 -9.014,-9.014Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressRejected);
export default __webpack_public_path__ + "static/media/iconB-progress-rejected.50d4289bad0088680893d78aa4e0c4c9.svg";
export { ForwardRef as ReactComponent };